import gql from 'graphql-tag';

import {
  AlbumFolderPrintOrderConfiguration,
  albumFolderPrintPackageDetails,
} from '../../../../../../../graphql/fragments/album-folder';
import { DigitalBundleDetails } from '../../../../../../../graphql/fragments/digital-bundles';

const albumFolderPricing = gql`
  fragment albumFolderPricing on AlbumFolder {
    id
    album_price_mode
    pre_paid: is_demo
    search_subscription_credits_joins_enabled
    album_delivery_modes {
      free_web_gallery
      photo_finder
      ppa
      shutterbug
    }
    price {
      value
      currency
    }
    discount_price {
      value
      currency
    }
    limited_time_offer_price {
      value
      currency
    }
    digital_bundles {
      total
      records {
        ...DigitalBundleDetails
      }
    }
    limited_time_offer_active
    limited_time_offer_date_start
    limited_time_offer_date_end
    ...albumFolderPrintPackageDetails
    ...AlbumFolderPrintOrderConfiguration
  }
  ${albumFolderPrintPackageDetails}
  ${DigitalBundleDetails}
  ${AlbumFolderPrintOrderConfiguration}
`;

export default albumFolderPricing;
